module.exports = __webpack_public_path__ + "static/media/corporate-services-img29.023377d9.jpg";